import axios from 'axios';
import { getApiUrl } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const guestKey = () => {
  const key = 'ubsa_assistant_guest';
  let value = localStorage.getItem(key);
  if (!value) {
    value = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(key, value);
  }
  return value;
};

const bookingAssistantAPI = {
  chat: (payload) =>
    axios.post(getApiUrl('/api/booking-assistant/chat'), payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),
  getSessions: () =>
    axios.get(getApiUrl('/api/booking-assistant/sessions'), { headers: authHeaders() }),
  getSession: (id) =>
    axios.get(getApiUrl(`/api/booking-assistant/sessions/${id}`), {
      headers: authHeaders(),
      params: { guestKey: guestKey() },
    }),
  guestKey,
};

export default bookingAssistantAPI;
